import { render, staticRenderFns } from "./question-records.vue?vue&type=template&id=ca3bc5b6&scoped=true"
import script from "./question-records.vue?vue&type=script&lang=js"
export * from "./question-records.vue?vue&type=script&lang=js"
import style0 from "./question-records.vue?vue&type=style&index=0&id=ca3bc5b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3bc5b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca3bc5b6')) {
      api.createRecord('ca3bc5b6', component.options)
    } else {
      api.reload('ca3bc5b6', component.options)
    }
    module.hot.accept("./question-records.vue?vue&type=template&id=ca3bc5b6&scoped=true", function () {
      api.rerender('ca3bc5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/question-records.vue"
export default component.exports